export default __webpack_public_path__ + "static/media/dra-ivani.a2add09c.png";